import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SectionMessageWrapper = styled.div`
  section {
    padding: ${Spacing.S8} ${Spacing.S12};
  }
`
